import React, { useEffect, useRef } from "react";
import { StyledButton } from "../../components/styledComponent/styledElements";
import { Col, Divider, Form, Row, Upload } from "antd";
import { CustomModal } from "../../components/styledComponent/styledModal";
import { AiOutlinePlus } from "react-icons/ai";
import { importData } from "../../server/uploadServices";
import { ShowNotification } from "../../components/notification/notification";
import { useAppContext } from "../../contexts/appContext";

const ImportDataModal = ({ showModal = false, setShowModal, setImporting }) => {
  const { startLoading, stopLoading } = useAppContext();
  const formRef = useRef();
  const onSubmitForm = () => {
    formRef.current.submit();
  };
  const onCancelForm = () => {
    formRef.current.resetFields();
    setShowModal(false);
  };
  const handleUploadFiles = (files) => {
    startLoading();
    importData(files)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Data Imported Successfully",
        });
        setShowModal(false);
        setImporting(true);
        formRef.current.resetFields();
      })
      .finally(() => {
        stopLoading();
      });
  };
  const uploadButton = (
    <StyledButton icon={<AiOutlinePlus size={18} />}>Import</StyledButton>
  );

  useEffect(() => {}, []);
  return (
    <CustomModal
      title={"Import Data"}
      open={showModal}
      onClose={onCancelForm}
      onCancel={onCancelForm}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancelForm}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onSubmitForm}>
          {"Save"}
        </StyledButton>,
      ]}
    >
      <Divider className="mt-0" />
      <Form ref={formRef} onFinish={handleUploadFiles} layout="vertical">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Products" name="products">
              <Upload
                listType="picture"
                beforeUpload={() => false}
                multiple={false}
                maxCount={1}
                accept=".csv"
              >
                {uploadButton}
              </Upload>
            </Form.Item>
            <Form.Item label="Categories" name="categories">
              <Upload
                listType="picture"
                beforeUpload={() => false}
                multiple={false}
                maxCount={1}
                accept=".csv"
              >
                {uploadButton}
              </Upload>
            </Form.Item>
            <Form.Item label="Photos" name="images">
              <Upload
                listType="picture"
                beforeUpload={() => false}
                multiple={false}
                maxCount={1}
                accept=".zip"
              >
                {uploadButton}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomModal>
  );
};

export default ImportDataModal;
